import React from "react"
import propTypes from "prop-types"
import i18n from "i18n"
import { Box, Button, Chip } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import SearchIcon from "@mui/icons-material/Search"
import LinkIcon from "@mui/icons-material/Link"

const AddPartidaActions = ({
  onSearch,
  onCreateManual,
  onImport,
  hideSearch,
  searchButtonProps,
  manualButtonProps,
  importButtonProps,
}) => {
  return (
    <Box sx={{ display: "flex", gap: "8px" }}>
      {!hideSearch && (
        <Button
          variant="contained"
          color="branded"
          size="small"
          startIcon={<SearchIcon fontSize="small" />}
          onClick={onSearch}
          sx={{ paddingInline: "16px", paddingBlock: "8px" }}
          {...searchButtonProps}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {i18n.t("Buscar partida")}
            <Chip
              label={i18n.t("Nuevo")}
              size="small"
              sx={{
                textTransform: "uppercase",
                height: "16px",
                fontSize: "9px",
                fontWeight: 700,
                color: "#000",
                backgroundColor: "#fdf5c9",
                borderRadius: "4px",
                "& .MuiChip-label": {
                  paddingInline: "8px",
                },
              }}
            />
          </Box>
        </Button>
      )}
      <Button
        variant="text"
        size="small"
        color="secondary"
        startIcon={<AddIcon fontSize="small" />}
        onClick={onCreateManual}
        sx={{ paddingInline: "16px", paddingBlock: "8px" }}
        {...manualButtonProps}
      >
        {i18n.t("Crear manualmente")}
      </Button>
      <Button
        variant="text"
        size="small"
        color="secondary"
        startIcon={<LinkIcon fontSize="small" />}
        onClick={onImport}
        sx={{ paddingInline: "16px", paddingBlock: "8px" }}
        {...importButtonProps}
      >
        {i18n.t("Importar")}
      </Button>
    </Box>
  )
}

AddPartidaActions.propTypes = {
  onSearch: propTypes.func.isRequired,
  onCreateManual: propTypes.func.isRequired,
  onImport: propTypes.func.isRequired,
  hideSearch: propTypes.bool,
  searchButtonProps: propTypes.object,
  manualButtonProps: propTypes.object,
  importButtonProps: propTypes.object,
}

export default AddPartidaActions
